import { render } from "./ImgSquare.vue?vue&type=template&id=1eff566d"
import script from "./ImgSquare.vue?vue&type=script&lang=js"
export * from "./ImgSquare.vue?vue&type=script&lang=js"

import "./ImgSquare.vue?vue&type=style&index=0&id=1eff566d&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__